<template>
  <div class="table-Wrapper">
    <v-simple-table :dense="dense" :fixed-header="fixedHeader" :height="height">
      <template v-slot:default>
        <thead>
          <tr class="header-row">
            <th v-if="index" class="text-left table-head">#</th>
            <th class="text-left" v-if="isCheckable">
              <v-checkbox
                dense
                v-if="multiSelect"
                :indeterminate="
                  selectedItems.length > 0 &&
                    selectedItems.length != tableData.length
                "
                :input-value="selectedItems.length == tableData.length"
                @click="toggleAllSelection"
              ></v-checkbox>
            </th>
            <th
              v-for="(header, index) in headers"
              :key="index"
              class="text-left table-head"
            >
              {{ header.label }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, i) in tableData" :key="i">
            <td class="table-row-data" v-if="index">{{ i + 1 }}</td>
            <td class="table-row-data" v-if="isCheckable">
              <v-checkbox
                dense
                v-model="selectedItems"
                :multiple="multiSelect"
                :value="item"
                label="data"
              ></v-checkbox>
            </td>
            <td
              class="table-row-data"
              v-for="(header, j) in headers"
              :key="j"
              @click="rowSelected(item)"
            >
              <template
                v-if="
                  header.type == 'action' ||
                    (header.name instanceof Array
                      ? item[header.name[0]]
                      : item[header.name])
                "
              >
                <div v-if="header.type == 'initials'" class="body-1">
                  <v-avatar color="blue darken-4" size="30">
                    <span class="white--text caption">{{
                      item[header.name]
                    }}</span>
                  </v-avatar>
                </div>
                <div v-if="header.type == 'avatar'" class="body-1">
                  <v-avatar>
                    <img
                      :src="item[header.name].imageUrl"
                      :alt="item[header.name].imageName || 'image'"
                    />
                  </v-avatar>
                </div>
                <div v-if="header.type == 'customer'" class="body-1">
                  {{ getCustomerName(item) }}
                </div>
                <div v-if="header.type == 'client'" class="body-1">
                  {{ getClientName(item) }}
                </div>
                <div v-if="header.type == 'text'" class="body-1">
                  {{ getValue(item, header.name) }}
                </div>
                <div v-if="header.label == 'Name'" class="caption grey--text">
                  {{ item["jobTitle"] || "" }}
                </div>
                <div v-if="header.type == 'value'" class="body-1">
                  {{ header.value }}
                </div>
                <div v-if="header.type == 'date'" class="body-1">
                  {{ getDateValue(item[header.name]) }}
                </div>
                <div v-if="header.type == 'status'" class="status">
                  <v-chip :color="getStatusColor(item[header.name])">{{
                    item[header.name]
                  }}</v-chip>
                </div>
                <div v-if="header.type == 'team'" class="team">
                  <team-view :team="item[header.name]" :size="35" />
                </div>
                <div v-if="header.type == 'action'" class="actions">
                  <v-menu bottom left>
                    <template v-slot:activator="{ on }">
                      <v-btn light icon v-on="on">
                        <v-icon>mdi-dots-horizontal</v-icon>
                      </v-btn>
                    </template>

                    <v-list>
                      <template
                        v-if="header.actions && header.actions.length > 0"
                      >
                        <v-list-item
                          v-for="(action, keyIndex) in header.actions"
                          :key="keyIndex"
                          @click="tableActions(item, action.value)"
                        >
                          <v-list-item-title>{{
                            action.label
                          }}</v-list-item-title>
                        </v-list-item>
                      </template>
                      <template v-else>
                        <v-list-item @click="updateItem(item)">
                          <v-list-item-title>Update</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="deleteItem(item)">
                          <v-list-item-title>Delete</v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-list>
                  </v-menu>
                </div>
              </template>
              <template v-else>-</template>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-dialog v-model="confirmDeleteDialog" max-width="450">
      <v-card>
        <v-card-title class="title"
          >Are you sure you want to delete this item?</v-card-title
        >
        <v-card-actions>
          <v-btn color="green darken-1" text @click="deleteCanceled"
            >Cancel</v-btn
          >

          <v-btn color="green darken-1" text @click="deleteConfirmed"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Excel from "exceljs";
import { saveAs } from "file-saver";
import TeamView from "@/components/TeamView.vue";
export default {
  name: "DataTable",
  components: {
    TeamView
  },
  props: {
    index: Boolean,
    dense: Boolean,
    multiSelect: Boolean,
    fixedHeader: Boolean,
    height: String || Number,
    headers: Array,
    content: Array,
    isCheckable: Boolean,
    projects: Array,
    clients: Array,
    customers: Array,
    searchString: String
  },
  data() {
    return {
      exportedContent: [],
      tableData: [],
      mainSelection: false,
      selectedItems: [],
      confirmDeleteDialog: false,
      deletedItem: null,
      worksheet: null,
      headersToExport: [
        "Employee Name",
        "Customer",
        "Project Name",
        "Start Date",
        "End Date",
        "Status",
        "Work Hours",
        "Extra Hours",
        "Time Offs",
        "Total Hours"
      ]
    };
  },
  created() {
    this.tableData = this.content;
  },
  watch: {
    selectedItems() {
      this.$emit("selected", this.selectedItems);
    },
    content() {
      // debugger;
      this.tableData = this.content;
      this.applySearch();
    },
    searchString() {
      // debugger;
      if (this.searchString) this.applySearch();
      else this.tableData = this.content;
    }
  },
  methods: {
    toggleAllSelection(event) {
      event.stopPropagation();
      this.mainSelection = !this.mainSelection;
      this.selectedItems = [];
      if (this.mainSelection) {
        this.selectedItems = this.tableData.slice(0);
      }
    },

    getDateValue(value) {
      if (!value) return "-";
      let dateFormat = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
      };
      value = new Date(value).toLocaleDateString("en-US", dateFormat);
      return value;
    },

    getValue(data, keyName) {
      let val = "";
      if (keyName instanceof Array) {
        keyName.forEach((key) => {
          val += data[key] + " ";
        });
      } else val = data[keyName];
      return val;
    },

    getCustomerName(item) {
      let id = item.customer;
      if (id) {
        let obj = this.customers.find((obj) => {
          return obj.id == id;
        });
        if (obj) {
          return obj.name;
        } else return "-";
      } else return "-";
    },

    getClientName(item) {
      let id = item.client;
      if (id) {
        let obj = this.clients.find((obj) => obj.id == id);
        if (obj) {
          return obj.name;
        } else return "-";
      } else return "-";
    },

    tableActions(item, val) {
      if (val == "update") this.updateItem(item);
      else if (val == "images") this.showImages(item);
      else if (val == "image") this.showImage(item);
      else this.$emit(val, item);
    },

    showImages(item) {
      this.$emit("display", item.images);
    },

    showImage(item) {
      this.$emit("image", item.imageObject);
    },

    rowSelected(item) {
      this.$emit("selectedRow", item);
    },

    updateItem(item) {
      this.worksheet = item;
      this.$emit("update", item);
    },
    refresh(status) {
      this.worksheet["status"] = status;
      this.$forceUpdate();
    },
    deleteItem(item) {
      this.deletedItem = item;
      this.confirmDeleteDialog = true;
    },

    deleteConfirmed() {
      this.confirmDeleteDialog = false;
      this.$emit("delete", this.deletedItem);
      this.deletedItem = null;
    },

    deleteCanceled() {
      this.deletedItem = null;
      this.confirmDeleteDialog = false;
    },

    getStatusColor(status) {
      let color = "";
      switch (status.toLowerCase()) {
        case "completed":
          color = "green lighten-3";
          break;
        case "active":
          color = "green lighten-3";
          break;
        case "upcoming":
          color = "blue lighten-3";
          break;
        case "in progress":
          color = "amber lighten-2";
          break;
        case "in-progress":
          color = "amber lighten-2";
          break;
        case "inactive":
          color = "red lighten-3";
          break;
        case "reserved":
          color = "brown darken-1";
          break;
        case "joining":
          color = "blue lighten-3";
          break;
        case "left":
          color = "light-green accent-4";
          break;
        case "accepted":
          color = "#caf1e3";
          break;
        case "pending":
          color = "#d2e0ff";
          break;
        case "in review":
          color = "#d2e0ff";
          break;
        case "rejected":
          color = "#ffc0c7";
          break;
        default:
          break;
      }
      return color;
    },

    getWorkHours(item) {
      var weekDays = item.data.workSheetData.weekDayList;
      var workHours = 0;
      weekDays.forEach((day) => {
        workHours += day.workHour;
      });
      return workHours;
    },

    getExtraHours(item) {
      var weekDays = item.data.workSheetData.weekDayList;
      var workHours = 0;
      weekDays.forEach((day) => {
        workHours += day.extraHour;
      });
      return workHours;
    },
    getTimeOffs(item) {
      var weekDays = item.data.workSheetData.weekDayList;
      var workHours = 0;
      weekDays.forEach((day) => {
        workHours += day.pto;
      });
      return workHours;
    },

    applySearch() {
      this.tableData = this.content;
      this.tableData = this.content.filter((item) => {
        let found = false;
        for (const key in item) {
          let val = item[key];
          if (val) {
            val = JSON.stringify(val).toLowerCase();
            if (val.search(this.searchString.toLowerCase()) != -1) {
              found = true;
              break;
            }
          }
        }
        return found;
      });
    },

    setExportedContent() {
      this.exportedContent = [];
      if (!this.selectedItems || this.selectedItems.length <= 0) {
        return false;
      }
      // var abc = [
      //   "Employee Name",
      //   "Customer",
      //   "Project Name",
      //   "Start Date",
      //   "End Date",
      //   "Status",
      //   "Work Hours",
      //   "Extra Hours",
      //   "Time Offs",
      //   "Total Hours",
      // ];
      this.selectedItems.forEach((item) => {
        let itemData = {};
        this.headersToExport.forEach((header) => {
          switch (header) {
            case "Employee Name":
              itemData[header] = item.employee;
              break;
            case "Customer":
              itemData[header] = item.customer;
              break;
            case "Project Name":
              itemData[header] = item.project;
              break;
            case "Start Date":
              itemData[header] = this.getDateValue(item.startDate);
              break;
            case "End Date":
              itemData[header] = this.getDateValue(item.endDate);
              break;
            case "Status":
              itemData[header] = item.status;
              break;
            case "Work Hours":
              itemData[header] = this.getWorkHours(item);
              break;
            case "Extra Hours":
              itemData[header] = this.getExtraHours(item);
              break;
            case "Time Offs":
              itemData[header] = this.getTimeOffs(item);
              break;
            case "Total Hours":
              itemData[header] = item.totalHours;
              break;
            default:
              break;
          }
        });
        this.exportedContent.push(itemData);
      });
      return true;
    },

    exportToExcel() {
      this.setExportedContent();
      if (this.exportedContent.length <= 0) {
        alert("Nothing to Export");
        return;
      }
      const workbook = new Excel.Workbook();
      const worksheet = workbook.addWorksheet("Sheet 01");

      worksheet.columns = this.headersToExport
        .filter((header) => !!header)
        .map((header) => {
          return {
            header: header,
            key: header
          };
        });
      worksheet.columns.forEach((col) => {
        col.width = col.header.length < 12 ? 12 : col.header.length * 2;
      });

      worksheet.addRows(this.exportedContent);

      worksheet.getRow(1).font = {
        name: "Arial",
        family: 4,
        color: { argb: "FF00FF00" },
        size: 14,
        bold: true
      };

      let fileName = "";
      let d = new Date();
      let month = d.getMonth() + 1;
      month = month.toString();
      fileName =
        d.getDate().toString() +
        month +
        "_" +
        d.getHours().toString() +
        "." +
        d.getMinutes().toString() +
        "." +
        d.getSeconds().toString();

      workbook.xlsx.writeBuffer().then(function(buffer) {
        saveAs(new Blob([buffer]), fileName + ".xlsx");
      });
    }
  }
};
</script>

<style scoped>
.theme--light.v-data-table.v-data-table--fixed-header thead th {
  background: transparent;
}
.table-Wrapper {
  margin: 17px;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0 2px 4px -1px gray;
}

.table-head {
  font-size: 13px;
  font-weight: bolder;
  color: #222;
}

.theme--light.v-data-table thead tr th {
  color: #222;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bolder;
}

.header-row {
  background: linear-gradient(to right, #eef5ff, #eef5fd);
}

.table-row-data {
  padding: 10px 15px;
}
</style>
